var stj = typeof stj !== 'undefined' ? stj : {};
window.actionTrackings = window.actionTrackings || [];
window.dataLayer = window.dataLayer || [];

stj.global = {
    SESSION_STORAGE_NAME_FOR_FIND_CLICK: 'userClickOnFindTimestamp',

    mobile: ApplicationProperties.get('touch'),
    windowName: 'mainWin',
    newTab: false,
    localStorageSupported: null,
    sessionStorageSupported: null,
    defaultPageTitle: '',
    switchPageTitleInterval: null,

    getQueryParam: function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);

        return results === null
            ? ''
            : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    setCookie: function (name, value, expires, path, domain, secure) {
        $.cookie(name, value, {
            expires: expires || '',
            path: path || '',
            domain: domain || ApplicationProperties.get('trackerDomainName'),
            secure: secure || '',
        });
    },

    getCookie: function (name) {
        return $.cookie(name);
    },

    removeCookie: function (name) {
        return $.removeCookie(name, {});
    },

    getHashCode: function (input) {
        switch (typeof input) {
            case 'number':
            case 'boolean':
            case 'function':
            case 'undefined':
                input = String(input);
                break;

            case 'object':
                input = JSON.stringify(input);
                break;

            default:
                // nothing
                break;
        }
        var hash = 0;
        var inputLength = input.length;
        for (var i = 0; i < inputLength; i++) {
            var character = input.charCodeAt(i);
            /* @codingStandardsIgnoreStart */
            hash = (hash << 5) - hash + character;
            hash &= hash;
            /* @codingStandardsIgnoreEnd */
        }
        return hash;
    },

    generateUID: function () {
        return 'xxxxxxx'.replace(/[x]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },

    scrollToTop: function (timeout) {
        if (ApplicationProperties.get('isAppMode')) {
            var scrollToElm = document.getElementById('appModeScrollToElm');
            this.scrollToElm(scrollToElm, true);
        } else {
            var animateTimeOut = timeout || 1;
            $('html,body').animate(
                {
                    scrollTop: 0,
                },
                animateTimeOut
            );
        }
    },

    scrollToElm: function (DOMnode, force) {
        var scrollToElm = false;

        if (typeof DOMnode.get === 'function') {
            // is a jquery object
            scrollToElm = DOMnode.get(0);
        } else {
            scrollToElm = DOMnode;
        }

        if (!scrollToElm) {
            return;
        }

        var scrollToElmOffset = $(scrollToElm).offset();

        if (!force && scrollToElm.scrollIntoViewIfNeeded) {
            scrollToElm.scrollIntoViewIfNeeded();
        } else if (scrollToElm.scrollIntoView) {
            scrollToElm.scrollIntoView({
                behavior: 'smooth',
            });
        } else if (
            !ApplicationProperties.get('isAppMode') &&
            scrollToElmOffset
        ) {
            $('html, body').animate(
                {
                    scrollTop: scrollToElmOffset.top,
                },
                'fast'
            );
        }
    },

    googleOptout: function () {
        var gaIds = ApplicationProperties.get('googleAccountIds');

        for (var gaId in gaIds) {
            var gaProperty = gaIds[gaId];
            var disableStr = 'ga-disable-' + gaProperty;

            this.setOptOutCookieAndGlobalVarByName(disableStr);
        }
    },

    gtmOptOut: function () {
        if (window.processOptOut) {
            window.processOptOut();
        } else if (
            typeof cookieBanner !== 'undefined' &&
            cookieBanner.processOptOut
        ) {
            cookieBanner.processOptOut();
        } else {
            this.setOptOutCookieAndGlobalVarByName('GTM-optout');
        }
    },

    setOptOutCookieAndGlobalVarByName: function (name) {
        if (document.cookie.indexOf(name + '=true') === -1) {
            document.cookie =
                name + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
            window[name] = true;
        }
    },

    removeCookiesByPattern: function (pattern) {
        var cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/);

        var cookieLength = cookieNames.length;
        for (var i = 0; i < cookieLength; i++) {
            if (pattern.test(cookieNames[i])) {
                document.cookie =
                    cookieNames[i] +
                    '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
            }
        }
    },

    removeWindowVarByPattern: function (pattern) {
        for (var prop in window) {
            if (pattern.test(prop)) {
                delete window[prop];
            }
        }
    },

    translate: function (transObj) {
        return js_tr[transObj.context][transObj.source];
    },

    //Detect iPhone and iPad
    isAppleMobile: function () {
        return /iP(ad|hone|od)/.test(navigator.userAgent);
    },

    /**
     * Determine if isJsonString
     * @param  {Function} fn
     * @return {Boolean}
     */
    isJsonString: function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },

    checkLocalStorage: function () {
        if (this.localStorageSupported === null) {
            this.localStorageSupported = this.isLocalStorageSupported();
        }
        return this.localStorageSupported;
    },

    checkSessionStorage: function () {
        if (this.sessionStorageSupported === null) {
            this.sessionStorageSupported = this.isSessionStorageSupported();
        }
        return this.sessionStorageSupported;
    },

    /**
     * Determine if localStorage is supported
     * @return {boolean}
     */
    isLocalStorageSupported: function () {
        return this.storageSupported(window.localStorage);
    },

    /**
     * Determine if sessionStorage is supported
     * @return {boolean}
     */
    isSessionStorageSupported: function () {
        return this.storageSupported(window.sessionStorage);
    },

    storageSupported: function (storage) {
        if (
            !storage ||
            !storage.setItem ||
            !storage.removeItem ||
            !storage.getItem
        ) {
            return false;
        }
        try {
            var test = '__storage_test__';
            storage.setItem(test, test);
            storage.removeItem(test);
            return true;
        } catch (exception) {
            if (ApplicationProperties.get('debug')) {
                console.log(exception);
            }
            return false;
        }
    },

    setLocalStorage: function (key, value) {
        if (this.checkLocalStorage()) {
            localStorage.setItem(key, value);
        } else {
            this.setCookie(key, value, '', '/');
        }
    },

    getLocalStorage: function (key) {
        if (this.checkLocalStorage()) {
            return localStorage.getItem(key);
        }
        return this.getCookie(key) || null;
    },

    removeLocalStorage: function (key) {
        if (this.checkLocalStorage()) {
            localStorage.removeItem(key);
        } else {
            this.setCookie(key, null, '', '/');
        }
    },

    setSessionStorage: function (key, value) {
        if (this.checkSessionStorage()) {
            sessionStorage.setItem(key, value);
        }
    },

    getSessionStorage: function (key) {
        if (this.checkSessionStorage()) {
            return sessionStorage.getItem(key);
        }
        return null;
    },

    removeSessionStorage: function (key) {
        if (this.checkSessionStorage()) {
            sessionStorage.removeItem(key);
        }
    },

    getOriginPage: function () {
        var gridId = ApplicationProperties.get('gridId');

        if (/\/seo\//.test(gridId)) {
            return 2;
        }

        if (/\/sem/.test(gridId)) {
            return 3;
        }

        if (gridId === 'index') {
            return 1;
        }

        return 4;
    },

    /**
     * @see https://gist.github.com/Integralist/1525378
     * @param object
     * @param property
     * @returns {boolean}
     */
    isHostMethod: function (object, property) {
        var type = typeof object[property];

        return (
            type === 'function' ||
            (type === 'object' && !!object[property]) ||
            type === 'unknown' ||
            type === 'string'
        );
    },

    enableJsMode: function () {
        $('#javascriptInput').val('1');
        $('.nojs').removeClass('nojs');
        $('.jsonly').removeClass('jsonly');
        $('.jshide').hide();
    },

    templateString: function (string, vars) {
        for (var p in vars) {
            string = string.replace(new RegExp('{' + p + '}', 'g'), vars[p]);
        }
        return string;
    },

    showIpGroup: function () {
        var ipGroup = ApplicationProperties.get('ipGroup');
        if (!ipGroup) {
            return;
        }
        var groupHolder = document.createElement('small');
        groupHolder.id = 'groupHolder';
        groupHolder.innerHTML = ipGroup;
        groupHolder.style.top = 0;
        groupHolder.style.padding = '0.4em';
        groupHolder.style.position = 'absolute';
        groupHolder.style.zIndex = 9999;

        document.body.appendChild(groupHolder);
    },

    initTrackingForUpsellLinks: function () {
        $('.serp-filter-link').on('click', function (event) {
            window.actionTrackings.push({
                acTrAc: 'upsellLink',
                acTrLa: $(this).data('upsell-type'),
            });
        });
    },

    getCurrentDate: function () {
        var currentDate = new Date();
        return {
            year: currentDate.getFullYear(),
            month: currentDate.getMonth() + 1,
            day: currentDate.getDate(),
        };
    },

    ucfirst: function (string) {
        return string[0].toUpperCase() + string.slice(1);
    },

    isWaitForPerl: function () {
        return ApplicationProperties.get('gridId') === 'search/wait';
    },

    isSerp: function () {
        return ApplicationProperties.get('gridId') === 'search/result';
    },

    isSelectStation: function () {
        return (
            ['booking/select-station-map', 'booking/select-station'].indexOf(
                ApplicationProperties.get('gridId')
            ) !== -1
        );
    },

    isPersonalData: function () {
        return ApplicationProperties.get('gridId') === 'booking/personal-data';
    },

    isSuccessPage: function () {
        return ApplicationProperties.get('gridId') === 'booking/success';
    },

    addTouchDeviceTracking: function () {
        var processClickTracking = function (label) {
            window.actionTrackings.push({
                acTrAc: 'clicked',
                acTrLa: label,
            });
        };
        $('#toMobile').on('click', function () {
            processClickTracking('toMobile');
        });

        $('#toDesktop').on('click', function () {
            processClickTracking('toDesktop');
        });

        // header - phone call green phone-icon
        $('header a.service-number').on('click', function () {
            processClickTracking('phone_call_header');
        });

        // footer - phone call in opend layer (foreign)
        $('.phone-button-call-foreign').on('click', function () {
            processClickTracking('phone_call_foreign');
        });

        // footer - phone call in opend layer (local)
        $('.phone-button-call').on('click', function () {
            processClickTracking('phone_call');
        });

        // footer - opens layer (local)
        $('#hotline').on('click', function () {
            processClickTracking('phone_bottom');
        });

        $('#airportButton').on('click', function () {
            processClickTracking('airport_click');
        });

        $(document).on('click', '.voucher-resend-link a', function () {
            processClickTracking('phoneTooltipVoucherLink');
        });
    },

    trackCurrentFindClickTimestamp: function () {
        this.setSessionStorage(
            this.SESSION_STORAGE_NAME_FOR_FIND_CLICK,
            Date.now()
        );
    },
};

function openPopup(URL, TARGET, OPT) {
    if (typeof OPT === 'object') {
        OPT = Object.assign(
            {
                width: 400,
                height: 400,
                center: true,
            },
            OPT
        );

        if (OPT.center) {
            OPT.left = ($(window).width() - OPT.width) / 2;
            OPT.top = ($(window).height() - OPT.height) / 2;
        }

        var array = [];
        for (var ia in OPT) {
            array.push(ia + '=' + OPT[ia]);
        }
        OPT = array.join(',');
    }
    window.open(URL, TARGET, OPT);
}

function openDetailsWindow(theURL, winName, features) {
    theURL = addSelectedValue(
        'depStationSignature',
        theURL,
        'selected_dep_signature'
    );
    theURL = addSelectedValue(
        'destStationSignature',
        theURL,
        'selected_dest_signature'
    );
    theURL = addSelectedValue('depHour', theURL, 'dep_hour');
    theURL = addSelectedValue('destHour', theURL, 'dest_hour');
    theURL = addSelectedValue('depMinute', theURL, 'dep_minute');
    theURL = addSelectedValue('destMinute', theURL, 'dest_minute');

    try {
        var detailWindow = window.open(theURL, winName, features);
        detailWindow.trigger('focus');
    } catch (e) {}

    function addSelectedValue(name, url, nameInUrl) {
        var elements = document.getElementsByName(name);
        if (elements && elements.length > 0) {
            var selectedElement = elements[0];
            try {
                var value =
                    selectedElement[selectedElement.selectedIndex].value;
                url += '&' + nameInUrl + '=' + encodeURIComponent(value);
            } catch (e) {
                url +=
                    '&' +
                    nameInUrl +
                    '=' +
                    encodeURIComponent(selectedElement.value);
            }
        }

        return url;
    }
}

window.mobile = stj.global.mobile;
window.name = stj.global.windowName;

$(function () {
    var eyecatcher = $('.eyecatcher');

    if (false === $.support.leadingWhitespace) {
        $('#headerNavigation > li')
            .on('mouseover', function () {
                $(this).addClass('hover');
            })
            .on('mouseout', function () {
                $(this).removeClass('hover');
            });
    }

    $('.marking').on('click', function () {
        $(this).select();
        return false;
    });

    // upsale-link in insurance-tooltip AB-Test 'comprehensiveCoverageWording' version 'coverage_classes'
    $(document).on('click', '.insurance-upsale', function () {
        var insuranceData = $(this).find('a').attr('data-insurance-upsale');
        var linkSource = $(this).find('a').attr('data-insurance-link-source');
        var mediumInsurance = $(
            '#insfull:not(:checked), #fib_aic:not(:checked)'
        );
        var highInsurance = $(
            '#insfull:not(:checked), #fib_aic:not(:checked), #fib_aia:not(:checked)'
        );
        var premiumInsurance = $(
            '#insfull:not(:checked), #fib_aic:not(:checked), #fib_aia:not(:checked), #fib_aib:not(:checked)'
        );
        if (insuranceData === 'to_medium') {
            mediumInsurance.trigger('click');
        } else if (insuranceData === 'to_high') {
            highInsurance.trigger('click');
        } else if (insuranceData === 'to_premium') {
            premiumInsurance.trigger('click');
        }
        $('.tooltip').hide();

        window.actionTrackings.push({
            trackEvent: 'insuranceUpsaleLink',
            acTrAc: insuranceData,
            acTrLa: linkSource,
        });
    });

    // BM-77482 customer feedback survey on bookit
    var feedbackSurvey = $('#grid-customer-feedback-survey');
    if (ApplicationProperties.get('isBookitSurveyActive')) {
        setTimeout(function () {
            feedbackSurvey.addClass('opened');
        }, 5000);
    }

    if (!ApplicationProperties.get('isTestEnvironment', false)) {
        $('body').addClass('smooth-scroll');
    }

    function closeSurvey() {
        feedbackSurvey.removeClass('opened');
    }

    function nextSurvey(container) {
        container.hide();
        var surveyContainer = container.next();
        if (surveyContainer.length) {
            surveyContainer.show();
        } else {
            closeSurvey();
        }
    }

    if (feedbackSurvey) {
        $('#grid-customer-feedback-survey .icon-close').on(
            'click',
            closeSurvey
        );

        $('#grid-customer-feedback-survey .survey-option').on(
            'click',
            function () {
                var input = $(this);
                var container = input.parents('.survey-container');
                var action = container
                    .parents('#customer-feedback-survey')
                    .attr('data-bookingnumber');
                var question = container.find('h3').attr('id');

                var inputId = input.attr('id');
                var answer = '';

                if (inputId) {
                    answer = input.attr('id').split('-')[1];
                } else {
                    answer = container.find('textarea#answer').val();
                }

                var label = question + '_' + answer;

                nextSurvey(container);
                setSurveyTracking('survey_v1', action, label);
            }
        );
    }

    function setSurveyTracking(category, action, label) {
        window.actionTrackings.push({
            trackEvent: category,
            acTrAc: action,
            acTrLa: label,
        });
    }

    $('#tipOpenTime, #tipOpenTimeAdvice')
        .tooltip({
            template: 'openTime',
            type: 'template',
            width: '290',
            closeDelay: true,
            position: ApplicationProperties.get('touch') ? 'left' : 'bottom',
        })
        .on('hover', function () {
            var telNumberHovered =
                stj.global.getSessionStorage('telNumberHovered');

            if (!telNumberHovered) {
                stj.global.setSessionStorage('telNumberHovered', true);
                window.actionTrackings.push({
                    acTrAc: 'hovered_tooltip',
                    acTrLa: 'callcenter',
                });
            }
        });

    $(document).on('click', '.voucher-resend-link', function () {
        window.actionTrackings.push({
            acTrAc: 'clicked',
            acTrLa: 'phoneTooltipVoucherLink',
        });
    });

    $('#userlikeCustomTab').on('click', function () {
        window.actionTrackings.push({
            acTrLa: 'userlike',
        });
    });

    if ($('#carExample').length > 0 && eyecatcher.length > 0 && $.fn.tooltip) {
        eyecatcher.tooltip({
            template: 'carExample',
            position: 'right',
            type: 'content',
            width: '200',
        });
    }

    if (!ApplicationProperties.get('mobile')) {
        var scrollTimeout;
        $(window).on('scroll', function () {
            if (typeof TipoHideAll !== 'undefined') {
                if (scrollTimeout) {
                    clearTimeout(scrollTimeout);
                    scrollTimeout = null;
                }
                scrollTimeout = setTimeout(TipoHideAll, 250);
            }
        });
    }

    var toggleFilter = $('#toogleFilter');
    if (toggleFilter) {
        toggleFilter.on('click', function () {
            var $filterBox = $('#filterBox');
            $filterBox.toggle();
            if ($(this).hasClass('mote')) {
                $(this)
                    .find('span')
                    .toggleClass('flt-rgt flt-lft')
                    .end()
                    .find('i')
                    .toggleClass(
                        'flt-lft flt-rgt icn-arrow-left icn-arrow-right'
                    );
                $('.search-form-wrapper').toggleClass('form-filter-active');
            } else {
                $('.columnFull', '#content').toggleClass('form-filter-active');
                $('#gridSearchForm').toggleClass('long-search-form');
                $('.moreIcon').toggleClass('toggle-filter-active');
            }

            var isVisible = $filterBox.is(':visible');
            var label = 'close';
            if (isVisible) {
                label = 'open';
            }

            window.actionTrackings.push({
                acTrAc: 'searchform_more_options',
                acTrLa: label,
            });
        });
    }

    // Check for new tab event [strg] or [cmd] to prevent layovers
    $(document)
        .on('keydown', function (e) {
            stj.global.newTab = e.metaKey || e.ctrlKey;

            if (
                e.keyCode === 9 &&
                !e.ctrlKey &&
                !e.altKey &&
                ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'].indexOf(
                    e.target.nodeName
                ) !== -1
            ) {
                window.actionTrackings.push({
                    acTrAc: 'keyUsedInForm',
                    acTrLa: 'tab',
                });
            }
        })
        .on('keyup', function (e) {
            stj.global.newTab = false;
        })
        .on('mousedown', function (e) {
            stj.global.newTab = e.which === 2 || e.metaKey || e.ctrlKey;
        });

    stj.global.enableJsMode();
    stj.global.showIpGroup();
    stj.global.initTrackingForUpsellLinks();
    stj.global.addTouchDeviceTracking();

    if (navigator.permissions) {
        navigator.permissions
            .query({ name: 'notifications' })
            .then(function (result) {
                window.actionTrackings.push({
                    category: 'permissions',
                    action: 'notifications',
                    label: result.state,
                });
            });
        navigator.permissions
            .query({ name: 'push', userVisibleOnly: true })
            .then(function (result) {
                window.actionTrackings.push({
                    category: 'permissions',
                    action: 'push',
                    label: result.state,
                });
            });
    }
});
